import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-02/lesson-23/task-03";

const task: Slide = {
  title: "Which listening test design requires a higher number of participants?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
